'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetPayment = exports.submitCreditCardUpdateForm = exports.submitPaymentForm = exports.cancelSubscription = exports.fetchUpcomingInvoice = exports.clearCoupon = exports.fetchCoupon = exports.loadPlans = exports.setProrateDate = exports.clearPrefilledCard = exports.setViewState = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = require('lodash');

var _creditCardActions = require('../../../components/form/creditCard/creditCardActions');

var _formSubmissionExceptionHandler = require('../../../components/form/formSubmissionExceptionHandler');

var _formSubmissionExceptionHandler2 = _interopRequireDefault(_formSubmissionExceptionHandler);

var _navigationActions = require('../../../reducers/navigationActions');

var _currentUserActions = require('../../currentUserActions');

var _teamManagementSelectors = require('../team/teamManagementSelectors');

var _paymentSelector = require('./paymentSelector');

var _paymentService = require('./paymentService');

var _paymentConstants = require('./paymentConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setViewState = exports.setViewState = function setViewState(viewState) {
    return {
        type: _paymentConstants.PAYMENT_SET_VIEW_STATE,
        viewState: viewState
    };
};

var clearPrefilledCard = exports.clearPrefilledCard = function clearPrefilledCard() {
    return {
        type: _paymentConstants.PAYMENT_CARD_CLEAR
    };
};

var setProrateDate = exports.setProrateDate = function setProrateDate(date) {
    return {
        type: _paymentConstants.PAYMENT_SET_PRORATE_DATE,
        date: date
    };
};

var loadPlans = exports.loadPlans = function loadPlans(_ref) {
    var volume = _ref.volume;
    return function (dispatch) {
        dispatch({ type: _paymentConstants.PAYMENT_PLANS_FETCHING });

        (0, _paymentService.getPlans)({ volume: volume }).then(function (response) {
            var plans = response.data.plans;
            dispatch({ type: _paymentConstants.PAYMENT_PLANS_FETCHED, plans: plans });
        });
    };
};

var couponError = function couponError(couponCode) {
    return {
        type: _paymentConstants.PAYMENT_COUPON_FAILED,
        coupon: {
            error: true,
            id: couponCode
        }
    };
};

var fetchCoupon = exports.fetchCoupon = function fetchCoupon(couponCode) {
    return function (dispatch) {
        dispatch({ type: _paymentConstants.PAYMENT_COUPON_FETCHING });

        return (0, _paymentService.getCoupon)({ couponCode: couponCode }).then(function (response) {
            var coupon = response.data.coupon;

            // return an error if the coupon code exists but is invalid
            if (!coupon || !coupon.valid) {
                return dispatch(couponError(couponCode));
            }

            return dispatch({ type: _paymentConstants.PAYMENT_COUPON_FETCHED, coupon: coupon });
        }).catch(function (error) {
            return dispatch(couponError(couponCode));
        });
    };
};

var clearCoupon = exports.clearCoupon = function clearCoupon() {
    return { type: _paymentConstants.PAYMENT_COUPON_CLEAR };
};

var fetchUpcomingInvoice = exports.fetchUpcomingInvoice = function fetchUpcomingInvoice(_ref2) {
    var subscriptionId = _ref2.subscriptionId,
        customerId = _ref2.customerId,
        planInterval = _ref2.planInterval,
        coupon = _ref2.coupon,
        prorateDate = _ref2.prorateDate;
    return function (dispatch, getState) {
        dispatch({ type: _paymentConstants.PAYMENT_UPCOMING_FETCHING });

        var memberIds = (0, _teamManagementSelectors.selectedTeamMemberIdsSelector)(getState()).keySeq().toArray().join(',');

        (0, _paymentService.previewUpcomingInvoice)({ subscriptionId: subscriptionId, customerId: customerId, planInterval: planInterval, coupon: coupon, prorateDate: prorateDate, memberIds: memberIds }).then(function (response) {
            var invoice = response.data;
            dispatch({ type: _paymentConstants.PAYMENT_UPCOMING_FETCHED, invoice: invoice });
        }).catch(function (error) {
            dispatch({
                type: _paymentConstants.PAYMENT_UPCOMING_FAILED,
                invoice: {
                    error: true
                }
            });
        });
    };
};

var cancelSubscription = exports.cancelSubscription = function cancelSubscription(subscriptionId) {
    return function (dispatch, getState) {
        (0, _paymentService.deleteSubscription)({ subscriptionId: subscriptionId }).then(function (result) {
            return dispatch((0, _currentUserActions.refreshCurrentUser)());
        });
    };
};

var submitPaymentForm = exports.submitPaymentForm = function submitPaymentForm(params) {
    return function (dispatch, getState) {
        var plan = params.plan,
            cardPrefilled = params.cardPrefilled,
            prorateDate = params.prorateDate;

        var state = getState();

        var planInterval = plan;

        var currentUser = state.getIn(['app', 'currentUser']);
        var customerId = currentUser.get('customerId');
        var subscriptionId = currentUser.get('subscriptionId');

        var couponOb = (0, _paymentSelector.couponSelector)(state);
        var coupon = couponOb && couponOb.get('valid') && couponOb.get('id');

        var memberIds = (0, _teamManagementSelectors.selectedTeamMemberIdsSelector)(state).valueSeq().toArray().join(',');

        var tokenPromise = cardPrefilled ? Promise.resolve({}) : (0, _creditCardActions.requestStripeToken)(_extends({}, params, { form: _paymentConstants.PAYMENT_FORM_NAME }), dispatch);

        return tokenPromise.then(function (_ref3) {
            var token = _ref3.token;

            var tokenId = token && token.id;

            var customerPromise = customerId && tokenId ? (0, _paymentService.updateCustomer)({ token: tokenId, customerId: customerId }) : Promise.resolve({});

            var subscriptionPromise = subscriptionId ? (0, _paymentService.updateSubscription)({ subscriptionId: subscriptionId, planInterval: planInterval, coupon: coupon, prorateDate: prorateDate, memberIds: memberIds }) : (0, _paymentService.createSubscription)({ token: tokenId, planInterval: planInterval, coupon: coupon, prorateDate: prorateDate, memberIds: memberIds });

            dispatch(setViewState(_paymentConstants.PAYMENT_VIEW_STATES.PROCESSING));

            return customerPromise.then(function (customer) {
                return subscriptionPromise.then(function (subscription) {
                    dispatch(setProrateDate(null));
                    dispatch(setViewState(_paymentConstants.PAYMENT_VIEW_STATES.SUCCESS));
                    dispatch((0, _currentUserActions.refreshCurrentUser)());
                });
            }).catch(function (error) {
                dispatch(setViewState(_paymentConstants.PAYMENT_VIEW_STATES.CARD_FORM));

                var errorMessage = (0, _lodash.get)(error, 'response.data.error.detail');
                var errorOb = (0, _lodash.get)(error, 'response.data.error');
                if (errorOb && errorMessage) errorOb.message = errorMessage;

                return (0, _formSubmissionExceptionHandler2.default)({
                    dispatch: dispatch,
                    getState: getState,
                    form: _paymentConstants.PAYMENT_FORM_NAME,
                    sensitive: true
                })(error);
            });
        });
    };
};

var submitCreditCardUpdateForm = exports.submitCreditCardUpdateForm = function submitCreditCardUpdateForm(params) {
    return function (dispatch, getState) {
        var cardPrefilled = params.cardPrefilled,
            setLoading = params.setLoading,
            setSuccess = params.setSuccess,
            setInitial = params.setInitial;

        var customerId = getState().getIn(['app', 'currentUser', 'customerId']);
        if (!customerId || cardPrefilled) return;

        return (0, _creditCardActions.requestStripeToken)(_extends({}, params, { form: _paymentConstants.PAYMENT_FORM_NAME }), dispatch).then(function (_ref4) {
            var token = _ref4.token;

            var tokenId = token && token.id;

            setLoading();

            return (0, _paymentService.updateCustomer)({ token: tokenId, customerId: customerId }).then(function (customer) {
                setSuccess();
            }).catch(function (error) {
                setInitial();

                var errorMessage = (0, _lodash.get)(error, 'response.data.error.detail');
                var errorOb = (0, _lodash.get)(error, 'response.data.error');
                if (errorOb && errorMessage) errorOb.message = errorMessage;

                return (0, _formSubmissionExceptionHandler2.default)({
                    dispatch: dispatch,
                    getState: getState,
                    form: _paymentConstants.PAYMENT_FORM_NAME,
                    sensitive: true
                })(error);
            });
        });
    };
};

var resetPayment = exports.resetPayment = _navigationActions.navigateToRootWorkspace;


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/payment/paymentActions.js
// module id = 752
// module chunks = 0